export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#022326',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#3DF0F0',
  },
  {
    path: 'M291.584 329.216h64v310.272H541.44v55.296H291.584zM577.28 430.08h54.784v51.2h1.024c6.656-28.16 41.472-58.368 77.312-58.368a138.8288 138.8288 0 0 1 22.016 1.536v56.32c-8.192-1.024-16.896-2.56-25.088-2.56-39.936 0-71.68 32.256-71.68 90.624v125.952H577.28z',
    fill: '#CCFBFF',
  },
]
